import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=c9faa7d0&scoped=true&"
import script from "./Payments.vue?vue&type=script&lang=ts&"
export * from "./Payments.vue?vue&type=script&lang=ts&"
import style0 from "./Payments.vue?vue&type=style&index=0&id=c9faa7d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9faa7d0",
  null
  
)

export default component.exports